export const DEFAULT_DOMAIN = 'meet.jit.si';
export const JAAS_STAGING_DOMAIN = 'stage.8x8.vc';
export const JAAS_PROD_DOMAIN = '8x8.vc';
